import React, { useEffect } from "react";
import { Nav } from "react-bootstrap";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import "../Admin/admin.css"; // Reuse admin styles

const UserLayout = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const fullName = localStorage.getItem("fullName") || "User";

    useEffect(() => {
        const token = localStorage.getItem("token");
        const role = localStorage.getItem("role");
        if (!token || (role !== "reporter" && role !== "user" && role !== "admin")) {
            navigate("/login");
        }
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("role");
        localStorage.removeItem("email");
        localStorage.removeItem("fullName");
        localStorage.removeItem("userId");
        navigate("/");
    };

    // 🔥 ACTIVE LINK STYLE
    const isActive = (path) =>
        location.pathname === path ? "active" : "";

    return (
        <div className="d-flex">

            {/* ================= SIDEBAR ================= */}
            <div
                className="admin-sidebar text-white p-3 d-flex flex-column"
                style={{ minHeight: "100vh" }}
            >

                {/* LOGO */}
                <div className="text-center mb-4">
                    <img
                        src="/img/Logo.png"
                        alt="Logo"
                        style={{
                            width: "120px",
                            height: "120px",
                            objectFit: "contain",
                            borderRadius: "10px",
                        }}
                    />
                    <h6 className="mt-2">Reporter Panel</h6>
                    <small className="text-muted">{fullName}</small>
                </div>

                {/* NAVIGATION */}
                <Nav className="flex-column">

                    <Nav.Link
                        className={`text-white ${isActive("/user-panel/add-news")}`}
                        onClick={() => navigate("/user-panel/add-news")}
                    >
                        📰 Add News
                    </Nav.Link>

                    <Nav.Link
                        className={`text-white ${isActive("/user-panel/manage-news")}`}
                        onClick={() => navigate("/user-panel/manage-news")}
                    >
                        🛠 Manage News
                    </Nav.Link>

                </Nav>

                {/* LOGOUT BUTTON (BOTTOM) */}
                <div className="mt-auto">
                    <Nav.Link
                        className="logout-link"
                        onClick={handleLogout}
                    >
                        🚪 Logout
                    </Nav.Link>
                </div>

            </div>

            {/* ================= MAIN CONTENT ================= */}
            <div className="flex-grow-1 p-4 bg-light">
                <Outlet />
            </div>

        </div>
    );
};

export default UserLayout;
